export default {
  // Generic words/sentences
  device: 'Device',
  devices: 'Devices',
  deleteConfirmMessage: 'This is a permanent action and cannot be undone',
  validations: {
    required: 'Required',
    email: 'Must be an email address',
    password: 'Passwords must be at least 6 characters long',
  },
  navigation: {
    // Main nav
    dashboard: 'Dashboard',
    cohort: 'Cohort',
    view: 'View',
    rules: 'Rules',
    connect: 'Connect',
    learn: 'Learn',
    settings: 'Settings',
    help: 'Help',
    chat: 'Chat',

    // Sub nav
    information: 'Information',
    events: 'Events',
    inputs: 'Connections',
    configuration: 'Configuration',
    actions: 'Actions',
    getStarted: 'Get started',
    connections: 'Active',
    integrations: 'Integrations',
    properties: 'Properties',
    history: 'History',
    delete: 'Delete',
    tokens: 'Tokens',
    tutorial: 'Tutorial',
    whereExpressions: 'Expressions',
    releaseNotes: 'What\'s new',
    documentation: 'Documentation',
    about: 'About',
    myUser: 'My user',
    manageUsers: 'Manage users',
    filters: 'Filters',
    dashboards: 'Dashboards',
    kpis: 'KPIs',
    branding: 'Branding',
    myOtherPlan: 'My other plan',
    myFinalPlan: 'My final plan',
  },
  header: {
    // Header bar
    user: {
      settings: 'User settings',
      accounts: 'Switch account',
      releaseNotes: 'What\'s new',
      logout: 'Logout',
    },
  },
  cohort: {
    // Cohort page
    measurement: 'Metric',
    grouping: 'Group by property',
    pivot: 'Pivot property',
    filter: 'Scope filter',
    options: 'Options',
    advancedOptions: 'Advanced options',
    withIncompleteResults: 'Include incomplete results',
    clustering: 'Clustering',
    custom: 'Custom',
    runKpi: 'Run KPI',
    newKpi: 'New KPI',
    manageKpi: 'Manage',
    chooseExisting: 'Choose an existing KPI',
    selectPoint: 'Select a point to explore your data',
    groupByTime: 'Group by time',
    hideBarGaps: 'Hide bar gaps',
    showBarGaps: 'Show bar gaps',
    yAxis: 'Y axis scale',
    yAxisPercent: 'Y axis scale (as %)',
    limit: 'Limit to',
    relativeTime: 'Relative time',
    nonRelativeTime: 'Time grouping',
    valueBounds: 'Value bounds',
    ops: {
      mean: 'Mean',
      sum: 'Sum',
      min: 'Min',
      max: 'Max',
    },
  },
  kpi: {
    displayTypes: {
      single: 'Single value',
      gauge: 'Gauge',
      line: 'Line',
      bar: 'Columns',
      stackedBar: 'Stacked columns',
      groupedBar: 'Grouped columns',
      pie: 'Pie',
      tabular: 'Tabular',
      scatter: 'Scatter',
    },
    sxsDisplayTypes: {
      absolute: 'Previous and current values',
      delta: 'Absolute change from previous value',
      'delta-percent': 'Percentage change from previous value',
    },
  },
  ui: {
    // Generic UI text
    cancel: 'Cancel',
    save: 'Save',
    options: 'Options',
    auto: 'Auto',
    start: 'Start',
    end: 'End',
    top: 'Top',
    bottom: 'Bottom',
    all: 'All',
    results: 'Results',
    create: 'Create',
    manage: 'Manage',
    loadingOptions: 'Loading options...',
    chooseOption: 'Choose an option',
    choosePropertyOption: 'Choose a property',
    chooseFilterOption: 'Choose a filter',
    chooseTime: 'Choose a time period',
    ascending: 'Ascending',
    descending: 'Descending',
    sortBy: 'Sort by',
    sortByLabel: 'Sort by legend',
    exportAsCsv: 'Export data as CSV',
    disabledTimeFilter: 'Time based filters cannot be used for scoping',
    grid: {
      toggleProperties: 'Toggle properties',
      filterProperties: 'Filter properties',
    },
  },
  time: {
    // Partials
    last: 'Last',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    week: 'week',
    weeks: 'weeks',
    month: 'month',
    months: 'months',
    year: 'year',
    years: 'years',

    minute: '{n} minute | {n} minutes',
    hour: '{n} hour | {n} hours',
    day: '{n} day | {n} days',

    dayShort: {
      monday: 'm',
      tuesday: 't',
      wednesday: 'w',
      thursday: 't',
      friday: 'f',
      saturday: 's',
      sunday: 's',
    },

    oneHour: '1 hour',
    threeHours: '3 hours',
    sixHours: '6 hours',
    twelveHours: '12 hours',
    twentyFourHours: '24 hours',
    oneDay: '1 day',
    threeDays: '3 days',
    sevenDays: '7 days',
    fourteenDays: '14 days',
    thirtyDays: '30 days',
    sixtyDays: '60 days',
    ninetyDays: '90 days',
    oneHundredAndEightyDays: '180 days',
    threeMonths: '3 months',
    sixMonths: '6 months',
    oneYear: '1 year',

    // Full strings
    last5m: 'Last 5 minutes',
    last15m: 'Last 15 minutes',
    last30m: 'Last 30 minutes',
    last1h: 'Last 1 hour',
    last2h: 'Last 2 hour',
    last3h: 'Last 3 hours',
    last4h: 'Last 4 hours',
    last6h: 'Last 6 hours',
    last8h: 'Last 8 hours',
    last12h: 'Last 12 hours',
    last24h: 'Last 24 hours',
    last3d: 'Last 3 days',
    last7d: 'Last 7 days',
    last14d: 'Last 14 days',
    last30d: 'Last 30 days',
    last3months: 'Last 3 months',
    last6months: 'Last 6 months',
    last1year: 'Last 1 year',
  },
  dashboard: {
    dashboards: 'Dashboards',
    create: 'Create',
    manage: 'Manage',
    badWidgetConfig: 'Configure the widget to see your data',
    errorLoadingData: 'Error loading widget data',
    noDevices: 'No devices match your current scope',
    poweredBy: 'Powered by',
    goFullscreen: 'Hide sidebar and header',
    exitFullscreen: 'Exit fullscreen',
    unlock: 'Edit dashboard',
    lock: 'Stop editing dashboard',
    refresh: 'Refresh',
    view: 'Show in view',
    cohort: 'Show in cohort',
    listScope: 'Filter dashboard to the selected device',
    edit: 'Open widget settings',
    remove: 'Delete widget',
    floorplan: {
      devices: 'Devices',
    },
    widgets: {
      defaultStatusHeading: 'Status',
      defaultEventsChartHeading: 'Events',
      defaultPropertyHeading: 'Property values',
      defaultMapHeading: 'Map',
      defaultListHeading: 'List',
      defaultAggregateHeading: 'Time series chart',
      defaultCohortHeading: 'KPI',
      defaultFloorplanHeading: 'Floorplan',
      defaultDeviceHeading: 'Device details',
      defaultWorkflowHeading: 'Workflow',
      defaultAlarmsHeading: 'Alarms',
    },
  },
  map: {
    customMarkerColouring: 'Custom marker colouring',
    useHeatmap: 'Heatmap',
    weatherOverlay: 'Weather overlay',
  },
  view: {
    errorFetchingData: 'There was an error fetching your data',
    dataPeriod: 'Data period',
    historyPeriod: 'History period',
    filterDevices: 'Filter devices',
    showValuelessProperties: 'Show properties with no value',
    hideValuelessProperties: 'Hide properties with no value',
    enableHierarchy: 'Show hierarchical tree view',
    disableHierarchy: 'Show devices',
    zoomToBounds: 'Zoom to fit markers',
    closePane: 'Close pane',
    paneSettings: 'Pane settings',
    paneTitles: {
      list: 'List',
      map: 'Map',
      details: 'Details',
      history: 'History table',
      historyChart: 'History chart',
      lifecycle: 'Timeline',
      log: 'Log',
      actions: 'Webhook actions',
      actionsDisabled: 'Select a device to run actions',
    },
    history: {
      selectDevice: 'Select a single device and at least one property to view its history',
      selectLifecycle: 'Select a single device and choose a KPI to view its history',
      selectProperties: 'Select properties to view their history on the selected device',
      useRolledUpData: 'Use rolled up data',
      connectGaps: 'Connect gaps',
      timestamp: 'Timestamp',
      noData: 'There is no history for this device\'s properties in the requested time range',
    },
  },
  settings: {
    branding: {
      applicationInfo: 'Application info',
      colouring: 'Colouring',
      applicationTitle: 'Page title',
      applicationTitleInfo: 'This is the text that is displayed in the browser bar (next to the favicon)',
      favicon: 'Favicon',
      faviconInfo: 'This is the browser bar and favourites icon. Provide us a link to a .ico, .png or .gif file to use your own',
      dashboardLogo: 'Dashboard logo',
      dashboardLogoInfo: 'This is the image that is displayed at the top of the dashboard (leave blank to use our default)',
      navigationEmblem: 'Navigation emblem',
      navigationEmblemInfo: 'This is the image at the top left of the page, which links to the dashboard (leave blank to use our default)',
      uiColours: 'UI colours',
      chartColours: 'Chart colours',
      primaryColour: 'Primary colour',
      successColour: 'Success colour',
      warningColour: 'Warning colour',
      errorColour: 'Error colour',
      resetAllBranding: 'Reset all branding',
      revertToDefault: 'Revert to default',
      revertAllToDefault: 'Revert all to default',
      default: 'Default',
    },
    user: {
      userInformation: 'User information',
      firstName: 'First name',
      lastName: 'Last name',
      saveChanges: 'Save changes',
      apiKey: 'API key',
      showApiKey: 'Show API key',
      showToken: 'Show token',
      password: 'Password',
      changePassword: 'Change password',
      revokePassword: 'Revoke password',
      oldPassword: 'Old password',
      newPassword: 'New password',
      newPasswordRepeat: 'New password (repeat)',
      addPassword: 'Add password',
      linkedAccounts: 'Linked accounts',
      settings: 'Settings',
      useLightInterface: 'Use light interface',
      useDarkInterface: 'Use dark interface',
      invalidPassword: 'Invalid password',
      currentlyLinkedAccounts: 'Currently linked accounts',
      linkAccounts: 'Add linked account',
      linkAccount: 'Link to {0}',
      unlinkAccount: 'Unlink {0}',
      addGoogleOAuth: 'Add Google OAuth',
      googleOAuthWarning: 'Please note that if you choose to authorize your account through Google then you will no longer be able to login via your password.',
      understand: 'I understand',
      googleOAuthError: 'There was an issue with connecting your Google account. Please ensure that your Google email matches your account email.',
      oauthSuccessMessage: 'You have successfully connected your Google account. Next time you login, please do so with Google.',
    },
  },
  property: {
    editing: 'Editing property',
    name: 'Name',
    alias: 'Display name',
    rawType: 'Storage type',
    type: 'Data type',
    metadata: 'Metadata',
    metadataExtended: 'Mark property as editable metadata',
    hidden: 'Hidden',
    hiddenExtended: 'Hide property in UI',
    factor: 'Format factor',
    factorHelp: 'Property values in the UI will be multiplied by this number before formatting and displaying',
    formatString: 'Format string',
    enumKey: 'Key',
    enumLabel: 'Label',
    enumAdd: 'Add new enumeration',
    saveChanges: 'Save changes',
    cancelChanges: 'Cancel',
    firstSeen: 'First seen',
    lastSeen: 'Last seen',
    lastSet: '{0} (Last set)',
    showLastSet: 'Show last set',
    showLastSetExtended: 'Show the last time this property was set in the UI',
    expression: 'Expression',
    watchRef: 'Property to watch',
    untilSeconds: 'Seen in last',
  },
  connect: {
    getStarted: {
      title: 'Connect your data',
      via: 'via',
      custom: {
        intro: 'DevicePilot is easily integrated with any platform with very little coding. Just post incoming device data into DevicePilot in JSON as shown below (DevicePilot is schemaless).',
      },
    },
    properties: {
      empty: 'No properties found',
      emptyHelp: 'Once you have device data in the system, this page will be populated with all of the device properties.',
      emptySearch: 'There are no properties that match your current filter.',
      filter: 'Filter properties',
    },
  },
  userSidebar: {
    registerTitle: 'Your first steps...',
    registerLines: [
      '1. Sign up for an account',
      '2. Choose your integration / language',
      '3. See your data in action!',
    ],
    accountsTitle: 'You can add new or manage your accounts here',
    loginTitle: 'Did you know?',
    loginLines: [
      'You can set up multiple workspaces under the "Accounts" page',
      'You can create your own filters in three easy steps from the View page',
      'You can run custom queries on your data using Cohort Analysis',
      'There\'s no limit to how many widgets you use on your dashboard. Happy scrolling!',
      'You can speak to us at any time using our in-app live support chat',
      'You can toggle between Columns and Line visualisation for your KPIs',
      'You can get notified directly to Slack when your device goes offline',
      'You can track uptime over time using our Cohort Analysis',
      'We can help you measure availability on your device estate',
      'You can share your dashboards with your customers',
      'You should be getting your availability metrics from DevicePilot',
    ],
  },
  user: {
    // Register, login and user settings
    email: 'Email address',
    workEmail: 'Work email',
    password: 'Password',
    firstName: 'First name',
    lastName: 'Last name',
    phoneNumber: 'Phone number (optional)',
    login: 'Login',
    register: 'Register',
    forgotPassword: 'Forgotten password?',
    alternativeLogin: 'or login with',
    loginFail: 'Invalid email address or password',
    loginFailServer: 'Error connecting to the server, please try again in a moment',
  },
  login: {
    noMatchingUser: 'We could not find a user matching that email address',
    loginWithEmail: 'Login with email',
    loginWithGoogle: 'Login with Google',
    pleaseLoginWithGoogle: 'Please login with Google to continue',
    forgottenPassword: 'I\'ve forgotten my password',
    dontHaveAnAccount: 'Don\'t have an account?',
    registerHere: 'Register here',
    loginToYourAccount: 'Login to your account',
    resetCode: 'Verification code',
    newPassword: 'New password',
    resetPassword: 'Reset password',
    setPassword: 'Set your password',
    saving: 'Updating your password...',
    sentVerifyEmail: 'Welcome back! As this is your first time logging in, you\'ll need to set a password. We\'ve sent you an email so please check your inbox.',
    sentForgotEmail: 'We\'ve sent you an email to reset your password so please check your inbox. It may take a few minutes to arrive and remember to check your spam folder.',
    passwordMinLength: 'Passwords must be at least 6 characters long',
  },
  register: {
    registerTitle: 'Get started with DevicePilot',
    migrateToOAuth: 'The associated email address already belongs to an account. If you choose to migrate to OAuth you will no longer be able to login with a password.',
    migrate: 'Migrate',
    iAgreeToThe: 'I agree to the',
    privacyPolicy: 'Privacy Policy',
    signUpWithEmail: 'Sign up with email',
    or: 'or',
    signUpWithGoogle: 'Sign up with Google',
    alreadyHaveAnAccount: 'Already have an account?',
    loginHere: 'Login here',
    verifyAccountTitle: 'Verify your account',
    verifyAccountCopy: 'We have sent you an email to verify your account. You can return to this tab afterwards.',
  },
  accounts: {},
};
